import { Box, Typography } from '@mui/material';
import { HandlersUserDetailResponse } from '../../../../../app/athenaApiGen';

interface SelectedUserDisplayProps {
  selectedUser: HandlersUserDetailResponse | null;
}

export default function SelectedUserDisplay({
  selectedUser,
}: SelectedUserDisplayProps) {
  const getRolesString = () => {
    if (!selectedUser || !selectedUser.roles) return '';
    const all = selectedUser.roles
      .map((r) => r?.roleName ?? '')
      .filter(Boolean);
    // remove duplicates
    const unique = Array.from(new Set(all));
    return unique.join(', ');
  };
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 2,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 400,
            color: 'text.primary',
          }}
        >
          SELECTED USER:
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.primary',
          }}
        >
          {selectedUser
            ? selectedUser.userName ||
              selectedUser.userEmail ||
              JSON.stringify(selectedUser)
            : 'Select User from table'}
        </Typography>
      </Box>
      {selectedUser && (
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            fontStyle: 'italic',
          }}
        >
          Roles: {getRolesString() || 'None'}
        </Typography>
      )}
    </Box>
  );
}
